var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M9.225 4.55313C9.39375 4.2125 9.74062 4 10.1188 4H13.8813C14.2594 4 14.6062 4.2125 14.775 4.55313L15 5H18C18.5531 5 19 5.44687 19 6C19 6.55312 18.5531 7 18 7H6C5.44687 7 5 6.55312 5 6C5 5.44687 5.44687 5 6 5H9L9.225 4.55313ZM6 8H18V18C18 19.1031 17.1031 20 16 20H8C6.89688 20 6 19.1031 6 18V8ZM9 10C8.725 10 8.5 10.225 8.5 10.5V17.5C8.5 17.775 8.725 18 9 18C9.275 18 9.5 17.775 9.5 17.5V10.5C9.5 10.225 9.275 10 9 10ZM12 10C11.725 10 11.5 10.225 11.5 10.5V17.5C11.5 17.775 11.725 18 12 18C12.275 18 12.5 17.775 12.5 17.5V10.5C12.5 10.225 12.275 10 12 10ZM15 10C14.725 10 14.5 10.225 14.5 10.5V17.5C14.5 17.775 14.725 18 15 18C15.275 18 15.5 17.775 15.5 17.5V10.5C15.5 10.225 15.275 10 15 10Z",
          fill: "#717986",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }